const accountActivityUrl = "v1/credit/accounts/activity";
const accountFeaturesUrl = "v1/utility/account-management/product/features";
const autopayEligibilityUrl = "v1/credit/billing/payments/autopay/eligibility";
const autopayStatusUrl = "v1/credit/billing/payments/autopay";
const accountSummaryV2Url = "v2/credit/accounts/summary";
const autoRegisterUrl = "v1/credit/profiles/account-associations/sync";
const creditAccountsUrl = "v2/credit/accounts";
const creditHealthUrl = "v1/credit/accounts/credit-health";
const merchantInfoUrl = "/v1/utility/merchants";
const paymentEnterpriseEligibilityUrl = "v1/credit/billing/payments/eligibility";
const paymentMethodsUrl = "v1/credit/billing/payments/methods";
const paymentQueryUrl = "v1/credit/billing/payments";
const payoffQuoteUrl = "v1/credit/billing/payoff-quote";
const profileUrl = "v1/credit/accounts/profile";
const promotionsUrl = "v1/credit/accounts/manage-promotions/available";
const rewardsBalanceUrl = "/v1/credit/accounts/rewards/balance";
const rewardsCertificateUrl = "/v1/credit/accounts/rewards/certificate";
const statementsEnrollmentUrl = "v1/credit/accounts/statements/enrollment";
const statementsUrl = "v1/credit/accounts/statements";
const settlementEligibilityUrl = "v1/credit/account/payment-plans/settlement";
const cardActivationUrl = "v1/credit/cards/activate";
const travelNotificationUrl = "v1/credit/accounts/management/profile/travel";
export { accountActivityUrl, accountFeaturesUrl, accountSummaryV2Url, autoRegisterUrl, autopayEligibilityUrl, autopayStatusUrl, cardActivationUrl, creditAccountsUrl, creditHealthUrl, merchantInfoUrl, paymentEnterpriseEligibilityUrl, paymentMethodsUrl, paymentQueryUrl, payoffQuoteUrl, profileUrl, promotionsUrl, rewardsBalanceUrl, rewardsCertificateUrl, settlementEligibilityUrl, statementsEnrollmentUrl, statementsUrl, travelNotificationUrl };
//# sourceMappingURL=endpoints.js.map
